import BaseInputControl from "./BaseInputControl";
import type { HandleInputChange } from "./types";

type DateTimeInputProps = {
    name: string;
    value?: string | number;
    placeholder?: string;
    disabled?: boolean;
    onChange: HandleInputChange;
};

const DateTimeInput = ({ name, value, placeholder, disabled = false, onChange }: DateTimeInputProps) => {
    return (
        <BaseInputControl
            type="datetime"
            name={name}
            value={value}
            placeholder={placeholder}
            onChange={onChange}
            disabled={disabled}
        />
    );
};

export default DateTimeInput;
